import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Row,
  Col,
  Label
} from "reactstrap";
import TextInput from "../../components/InputFields/TextInput";
import { updatePatientById, deletePatientDocument, uploadOrUpdateDocument, getPatientDocuments} from "../../api/patient";
import { failed, success } from "../../utils/Tostify";
import DatePickerSelector from "../../components/InputFields/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import { formikDocument } from "./Constant";
import InputFile from "../../components/InputFields/InputFile";
import { handleFileUpload } from "../../utils/ImageToBase64";
import Loader from "../../components/Loader/Loader";
import { decryptData } from "../../utils/helper";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { getDocumentTypeList } from "../../api/workflow";

const DocumentList = ({ patientDeatils }) => {
  const [openModel, setOpenModel] = useState(false);
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  let user = useSelector(state => state.userReducer.user);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentList, setDocumentList] = useState(patientDeatils?.documents);
  const { getConfirmation } = useConfirmDialog();
  const [docData, setDocData] = useState();
  const [isExpirationDateMandatory, setIsExpirationDateMandatory] = useState(false);
  const [errorShow, setError] = useState("");
  const [documentsOptions, setDocumentsOptions] = useState([]);

  const getPatientDocument = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatientDocuments({ dispatch, token, id: patientDeatils?._id, userId : user?._id });
      const responseData = decryptData(res.data);
      if (res?.status === "SUCCESS") {
        setIsLoading(false);
        setDocumentList(responseData);
        console.log(responseData);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

const getDocumentList = async (page, limit, searchKey = "") => {
  let res;
  try {
      setIsLoading(true);
      res = await getDocumentTypeList({ dispatch, token, page, limit, searchKey });
      const responseData = decryptData(res?.data);

      if (res?.status === "SUCCESS" && Array.isArray(responseData.items)) {
          const patientState = patientDeatils?.address?.state;

          const filteredDocuments = responseData.items.filter((doc) =>
              doc.applicableStates?.some((state) => state.label === patientState)
          );

          const options = filteredDocuments.map((doc) => ({
              label: doc.documentTitle,
              value: doc._id
          }));

          setDocumentsOptions(options);
      } else {
          failed("Invalid response format or empty list");
      }
  } catch (error) {
      failed(res?.message || "Something went wrong");
  } finally {
      setIsLoading(false);
  }
};

useEffect(() => {
  getDocumentList(1, 100);
}, [patientDeatils]);


  const formik = useFormik({
    ...formikDocument,
    onSubmit: async (values) => {
      let base64pdfForm = "";
      let res;
      setIsLoading(true);
      try {
        if(isExpirationDateMandatory && !formik.values.expirationDate){
          setError("Required Expiration Date");
          return;
        }
        if (!docData) {
          if (values?.pdfForm?.name !== undefined) {
            base64pdfForm = await handleFileUpload(values?.pdfForm);
            const fileExtension = values?.pdfForm?.type?.split("/")[1];
            const pdfForm = {
              base64String: base64pdfForm,
              extension: fileExtension,
              name: values?.pdfForm.name,
              userId: patientDeatils?._id,
              documentTypeId: values.documentTypeId,
              expirationDate: values.expirationDate,
              uploadDate: new Date(),
              title: values.title,
              uploadedBy: user?._id
            };
            values.documents = pdfForm;
          }

          const payload = {
            file: values.documents
          };
          res = await updatePatientById({
            payload,
            dispatch,
            token,
            patientId: patientDeatils?._id
          });
        } else {
          // Update existing document
          res = await uploadOrUpdateDocument({
            values,
            dispatch,
            token,
            patientId: patientDeatils?._id,
            documentId: docData?._id
          });
        }
        if (res?.status === "SUCCESS") {
          handleCancel();
          getPatientDocument();
          if (!docData);
          success(res?.message);
        } else {
          failed(res?.message);
        }
      } catch (error) {
        failed(error?.message || "An error occurred");
      } finally {
        setIsLoading(false); // Stop loading in both success and error cases
      }
    }
  });

  useEffect(() => {
    if(patientDeatils?._id){
      getPatientDocument();
    }
  }, [patientDeatils?._id]);

  const handleCancel = () =>{
    setOpenModel(false);
    formik.setFieldValue("documentTypeId","");
    formik.setFieldValue("expirationDate","");
    formik.setFieldValue("documentFile",null);
    formik.setFieldValue("title","");
    setSelectedFile(null);
    setDocData();
    formik.resetForm();
    setIsExpirationDateMandatory(false);
    setError("");
  };

  const handleDownload = (url) =>{
    window.open(url, "_blank");
  };

  // const handleDeleteClick = async (documentId) => {
  //   let res;
  //   try {
  //     const confirmed = await getConfirmation({
  //       title: "Attention!",
  //       entryName: "",
  //       actionBtnTitle: "Yes",
  //       message: "Are you sure you want to delete the note?"
  //     });
  //     if (confirmed) {
  //       setIsLoading(true);
  //       res = await deletePatientDocument({ patientId: patientDeatils?._id, documentId, dispatch, token });
  //       if (res?.status === "SUCCESS") {
  //         await getPatientDocument();
  //         setIsLoading(false);
  //         success(res?.message);
  //       } else {
  //         setIsLoading(false);
  //         failed(res?.message);
  //       }
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //     failed(error?.message || "An error occurred");
  //   }
  // };

  useEffect(() => {
    if (docData) {
      formik.setValues({
        documentTypeId: docData?.documentTypeId ? docData?.documentTypeId : null,
        expirationDate: docData?.expirationDate ? moment(docData?.expirationDate).format("MM-DD-YYYY") : "",
        documentFile: docData?.documentFile ? docData?.documentFile : null,
        title: docData?.title ? docData?.title : ""
      });
    }
  }, [docData]);

  // const handleUpload = async (docId) => {
  //   // Create a file input dynamically
  //   const fileInput = document.createElement("input");
  //   fileInput.type = "file";
  //   fileInput.accept = ".pdf,.doc,.docx"; // Accept specific file types if needed
  //   let base64pdfForm= "";
  //   let res;
  //   // Handle the file selection
  //   fileInput.onchange = async (event) => {
  //     const selectedFile = event.target.files[0];
  //     if (selectedFile) {
  //       try {
  //         base64pdfForm = await handleFileUpload(selectedFile);
  //         const fileExtension = selectedFile?.type?.split("/")[1];

  //         const filePayload = {
  //           base64String: base64pdfForm,
  //           extension: fileExtension,
  //           name: selectedFile?.name,
  //           userId: patientDeatils?._id
  //         };
  //         // Call the API to upload or update the document
  //         const res = await uploadOrUpdateDocument({
  //           values: {file:filePayload},
  //           dispatch,
  //           token,
  //           patientId: patientDeatils?._id,
  //           documentId: docId
  //         });

  //         if (res?.status === "SUCCESS") {
  //           success(res?.message); // Show success message
  //           getPatientDocument(); // Refresh the data if needed
  //         } else {
  //           failed(res?.message); // Show error message
  //         }
  //       } catch (error) {
  //         console.error("File upload error:", error);
  //         failed("File upload failed.");
  //       }
  //     }
  //   };

  //   // Programmatically click the file input to open the file dialog
  //   fileInput.click();
  // };

  // const getDocumentTitle = (docTypeId) => {
  //   const docType = documentsOptions.find((type) => type.value === docTypeId);
  //   return docType ? docType.label : "Unknown Document Type"; // Fallback if not found
  // };
  return (
    <div>
      <div className="d-flex justify-content-between document_tabs_blk mb-3 align-items-center mt-3 gap-2 flex-wrap">
        {isLoading ? <Loader /> : null}
        <h4 className="m-0">Document List</h4>
        {/* <button className="btn_document" onClick={() => setOpenModel(true)}>
          Upload Document
        </button> */}
      </div>
      <div className="table-responsive">
        <table>
          <thead>
            <tr className="header_table">
              <th></th>
              <th>Document Name</th>
              <th>Document Type</th>
              <th>Uploaded By</th>
              <th>Updated Date</th>
              <th>Expiration Date</th>
              {/* <th>Status</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {documentList?.length > 0 ? (
              documentList?.map((doc, index) => (
                <>
                  <tr>
                    <td colSpan={9} height={5} className="bg_light"></td>
                  </tr>
                  <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                    <td>{index + 1}</td>
                    <td>{doc?.title}</td>
                    <td>{doc?.documentTypeDetails?.documentTitle}</td>
                    <td>{doc?.uploadedBy?.firstName ? `${doc.uploadedBy.firstName} ${doc.uploadedBy.lastName}` : ""}</td>
                    <td>{doc?.uploadDate && moment(doc?.uploadDate).format("MMM-DD-YYYY")}</td>
                    <td>{doc?.expirationDate && moment(doc?.expirationDate).format("MMM-DD-YYYY")}</td>
                    {/* <td>
                      <p className="valid_blk">
                        {doc?.expirationDate ? (
                         moment(doc.expirationDate).isBefore(moment(), 'day') ? (
                            <span style={{ color: 'red' }}>Expired</span>
                          ) : (
                            <span style={{ color: 'green' }}>Valid</span>
                          )
                        ) : (
                          <span>N/A</span>
                        )}
                      </p>
                    </td> */}
                    <td>
                      {/* <span className="material-symbols-outlined" onClick={()=>handleDownload(doc?.filePath?.publicUrl)}>
                        download
                      </span> */}
                      {doc?.filePath?.signedUrl && (
                      <span className="material-symbols-outlined" style={{ cursor: "pointer" }} onClick={()=>handleDownload(doc?.filePath?.signedUrl)}>
                        download
                      </span>)}
                      {/* <span className="material-symbols-outlined" style={{ cursor: "pointer" }} onClick={()=>handleUpload(doc?._id)}>upload</span>
                      <span className="material-symbols-outlined" style={{ cursor: "pointer" }} onClick={()=> {handleDeleteClick(doc?._id);}}>delete</span>
                      <span className="material-symbols-outlined" style={{ cursor: "pointer" }} onClick={()=> {setOpenModel(true);setDocData(doc);setIsExpirationDateMandatory(doc?.expirationDate);}}>edit</span> */}
                    </td>
                  </tr>
                </>
              ))
            ) : (
              <tr>
                <td colSpan={10}>
                  <p className="text-center">No Data Found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Modal isOpen={openModel} toggle={handleCancel} onClosed={handleCancel} size="lg" className="upload_document_modal">
        <Form onSubmit={formik.handleSubmit}>
          <ModalHeader toggle={() => setOpenModel(false)} className="assign_blk p-0">
            Upload Document
          </ModalHeader>
          <ModalBody className="m-0">
          {isLoading ? <Loader /> : null}
            <Row className="mb-2 mx-0">
              <Col lg={6} className="location_block">
                  <TextInput
                      keyField={"documentTypeId"}
                      label="Document Type"
                      formik={formik}
                      options={documentsOptions} // Updated dynamically
                      type="select"
                      placeholder="Select"
                      value={formik.values.documentTypeId}
                      onChange={(e) =>
                          formik.setFieldValue("documentTypeId", e.target.value)
                      }
                  />
              </Col>
              <Col lg={6} className="location_block">
                <TextInput
                keyField={"title"}
                formik={formik}
                required={true}
                label="Title"
                type="text"
                value={formik.values.title}
                onChange={(e) => formik.setFieldValue("title", e.target.value)}
                />
              </Col>
              <Col lg={6} className="location_block">
                <Label check>
                  <input
                    type="checkbox"
                    checked={isExpirationDateMandatory}
                    onChange={(e) => {setIsExpirationDateMandatory(e.target.checked);setError("");
                    if (!e.target.checked) {
                      formik.setFieldValue("expirationDate", "");
                    }}}
                  />
                  {' '}Is Expiration Date Mandatory?
                </Label>
              </Col>
              {isExpirationDateMandatory && (
              <Col lg={6} className="location_block">
                <DatePickerSelector
                  keyField={"expirationDate"}
                  formik={formik}
                  value={formik.values?.expirationDate}
                  minDate={moment()}
                  maxDate={""}
                  label="Expiration Date"
                  type="date"
                  required={isExpirationDateMandatory} // Make it mandatory if checkbox is checked
                  onChange={(e) =>
                    {formik.setFieldValue("expirationDate", moment(e).format("MM-DD-YYYY"));setError("");}
                  }
                />
                <span style={{color:"red"}}>{errorShow}</span>
              </Col>
            )}
            </Row>
            {!docData &&
            <div className="mx-0 upload_modall">
              <Label for="exampleFile" className="up_blk">Upload</Label>
              <InputFile
                keyField={"pdfForm"}
                id="exampleFile"
                name="file"
                type="file"
                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                multiple={false}
                inputFile="pdf"
                formik={formik}
                setFile={(file) => setSelectedFile(file)} // Pass file to formik and state
                imageUrl={selectedFile}
              />
            </div>}
          </ModalBody>
          <div className="d-flex justify-content-center gap-3 mt-2 mb-2">
            <button className="save_btn" type="button" onClick={()=>{handleCancel();}}>Cancel</button>
            <button className="save_btn saving" type="submit">
              Save
            </button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default DocumentList;
